import React from "react";
import { NursingQuestionId } from "../../../messages/ObjectIds";
import {
  NursingQuestionVBPAnswer,
  NursingQuestionVBPReportSubmit,
  NursingQuestionVBPWithAnswer,
} from "../../../messages/VBP";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { If } from "../../Generic/If";
import VBPQuestionCard from "./VBPQuestionCard/VBPQuestionCard";

interface Props {
  showAnsweredIndication: boolean;
  showTitle: boolean;
  nursingQuestionsVBPWithAnswers: NursingQuestionVBPWithAnswer[] | null;
  onVBPQuestionChange: (nursingQuestionVBPWithAnswer: NursingQuestionVBPWithAnswer) => void;
  onSubmitVBPQuestions: (
    nursingQuestionVBPReportSubmit: NursingQuestionVBPReportSubmit
  ) => Promise<void>;
  onVBPQuestionAnswer: (nursingQuestionVBPAnswer: NursingQuestionVBPAnswer) => Promise<void>;
  onVBPQuestionNotesClick: (vbpqQustionNotesAreOpen: boolean) => void;
}

const VBPQuestionsSection = (props: Props) => {
  return (
    <AppCard className="VBPQuestionsSection" style={{ margin: "16px 0", borderRadius: 0 }}>
      <If condition={props.showTitle}>
        <AppCardHeader>
          <AppCardTitle>{translate(STRINGS.PATIENT_REPORT)}</AppCardTitle>
        </AppCardHeader>
      </If>

      <AppCardContent>
        {props.nursingQuestionsVBPWithAnswers === null ? null : (
          <div className="container">
            {props.nursingQuestionsVBPWithAnswers.map((nursingQuestionVBPWithAnswer) => (
              <VBPQuestionCard
                showAnsweredIndication={props.showAnsweredIndication}
                key={NursingQuestionId.unwrap(nursingQuestionVBPWithAnswer.id)}
                nursingQuestionVBPWithAnswer={nursingQuestionVBPWithAnswer}
                onVBPQuestionChange={props.onVBPQuestionChange}
                onVBPQuestionAnswer={props.onVBPQuestionAnswer}
                onVBPQuestionNotesClick={props.onVBPQuestionNotesClick}
              />
            ))}
          </div>
        )}
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(VBPQuestionsSection);
